export const BANNER_TYPE = {
  about: 'about',
  general: 'general',
  generalUsers: 'generalUsers',
  generalPartners: 'generalPartners',
  test: 'test'
} as const;
